/**
 * What a customer sets up on their OWN Intercom app before pasting its credentials into Kim.
 * The lists mirror what Kim's own app asks for. No imports, so the node test runner can load it.
 */
export const INTERCOM_DEVELOPER_HUB_URL = 'https://app.intercom.com/a/apps/_/developer-hub';

/** Ticked under Configure → Authentication, exactly as Intercom labels them. */
export const INTERCOM_OWN_APP_PERMISSIONS = [
	'Read and list users and companies',
	'Read one user and one company',
	'Read conversations',
	'Write conversations',
	'Read tags',
	'Write tags',
	'Read admins',
	'Read one admin',
	'Read brands',
	'Read emails'
] as const;

/** Selected under Configure → Webhooks. */
export const INTERCOM_OWN_APP_WEBHOOK_TOPICS = [
	'conversation.user.created',
	'conversation.user.replied',
	'conversation.admin.replied',
	'conversation.admin.noted',
	'conversation.admin.closed',
	'conversation.admin.opened',
	'conversation.admin.snoozed',
	'conversation.admin.unsnoozed'
] as const;

export const INTERCOM_CREDENTIAL_MAX_LENGTH = 512;
